import { LiveTableProps } from "../../types";
import React, { useState } from "react";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { TableContainer } from "../../styles";
import Table, { TableColumn } from "../../../../../components/Table";
import { formatBrandCodeView, formatDateView, formatMoneyCentsView, formatDocument } from "../../../../../utils/formatViews";

export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
 }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formatPaymentStatus = (status: boolean) => {
    if (status == undefined || status == null) {
      return "";
    }

    if (status === false) {
      return "Falha";
    }
    else if (status === true) {
      return "Sucesso";
    }
  }

  const formatCustomerType = (customerType: string) => {
    if (customerType === "F") {
      return "Pessoa Física";
    }
    if (customerType === "J") {
      return "Pessoa Jurídica";
    }
    if (customerType === "C") {
      return "Credor";
    }

    return "";
  }

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} liquidações falhas`,
            }}
        >
          <TableColumn title="Data Recebimento" dataIndex="receiveDate" key="brand" render={formatDateView} />
          <TableColumn title="Cód. Lojista" dataIndex="merchantId" key="merchantId" />
          <TableColumn title="Arquivo" dataIndex="fileName" key="fileName" />
          <TableColumn title="Titular da Conta" dataIndex="holderName" key="holderName" />
          <TableColumn title="Valor não pago" dataIndex="paymentValue" key="paymentValue" render={formatMoneyCentsView}/>
          <TableColumn title="Valor Descontado" dataIndex="discountedValue" key="discountedValue" render={formatMoneyCentsView}/>
          <TableColumn title="Identificador Pagamento" dataIndex="paymentIdentifier" key="paymentIdentifier" />
          <TableColumn title="Tipo Conta" dataIndex="accountType" key="accountType" />
          <TableColumn title="Banco" dataIndex="bankCode" key="bankCode" />
          <TableColumn title="Agência" dataIndex="bankBranch" key="bankBranch" />
          <TableColumn title="Conta bancária" dataIndex="bankAccount" key="bankAccount" />
          <TableColumn title="Bandeira" dataIndex="brandCode" key="brandCode" render={formatBrandCodeView} />
          <TableColumn title="Tipo do Recebedor" dataIndex="customerType" key="customerType" render={formatCustomerType}/>
          <TableColumn title="Documento Recebedor" dataIndex="customerDocument" key="customerDocument" render={formatDocument}/>
          <TableColumn title="Mensagem de erro" dataIndex="message" key="message"/>
          <TableColumn title="Atualizado em" dataIndex="lastUpdate" key="lastUpdate" render={formatDateView} />
        </Table>
      </TableContainer>
    </div>
  )
}
